import { render, staticRenderFns } from "./ModalHtml.vue?vue&type=template&id=590a31fd&"
import script from "./ModalHtml.vue?vue&type=script&lang=js&"
export * from "./ModalHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590a31fd')) {
      api.createRecord('590a31fd', component.options)
    } else {
      api.reload('590a31fd', component.options)
    }
    module.hot.accept("./ModalHtml.vue?vue&type=template&id=590a31fd&", function () {
      api.rerender('590a31fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/ModalHtml.vue"
export default component.exports